// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"Error_centeredContainer__DP5Qt","imageContainer":"Error_imageContainer__w9tET","button":"Error_button__Gw6_j"};